import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class SchedualDetailService {
  constructor() {}

  async mapConfigs(config) {
    const groupedArray = Object.entries(config).reduce((acc, [key, value]) => {
      const prefix = key; // Extract the starting key

      if (
        !acc[prefix] &&
        ![
          "LOW",
          "HIGH",
          "EQUAL",
          "NOT_EQUAL",
          "BETWEEN_MAX",
          "BETWEEN_MIN",
        ].some((suffix) => prefix.toUpperCase().endsWith(suffix))
      ) {
        acc[prefix] = [];
      }

      let array =
        acc[
          prefix.replace(
            /_(LOW|Low|low|HIGH|High|high|NOT_EQUAL|BETWEEN_MAX|BETWEEN_MIN|EQUAL)$/,
            ""
          )
        ];
      if (array) {
        array.push({ key, value });
      }
      return acc;
    }, {});

    // Convert to an array
    let resultArray = Object.entries(groupedArray).map(([group, items]) => ({
      group,
      items,
    }));

    const mapConfigs = await Promise.all(
      resultArray.map(async (arr) => {
        let conditions = [];
        if (
          arr.items["find"]((item) =>
            item.key.toUpperCase().includes("BETWEEN")
          )
        ) {
          let target = arr.items["find"](
            (item) => !item.key.toUpperCase().includes("BETWEEN")
          );
          let targetStart = arr.items["find"]((item) =>
            item.key.toUpperCase().includes("MIN")
          );
          let targetEnd = arr.items["find"]((item) =>
            item.key.toUpperCase().includes("MAX")
          );

          conditions.push({
            sch_status: target.value == 1 ? "ATV" : "ITV",
            condition: 5,
            time: 5,
            target_start: targetStart.value,
            target_end: targetEnd.value,
            time_unit: "minutes",
            switch_main: true,
          });

          let items = arr.items["filter"](
            (item) => !item.key.toUpperCase().includes("BETWEEN")
          );

          if (items.length > 1) {
            let configs = this.addConfig(items);
            configs.map((config) => {
              conditions.push(config);
            });
          }
        } else {
          conditions = this.addConfig(arr.items);
        }
        return {
          ...arr,
          conditions: conditions,
          checked: true,
        };
      })
    );

    return mapConfigs;
  }

  getThing(things, selectThingId){
    return things.find(thing=> thing.thing_id == selectThingId);
  }

  getOnlineConfig(onlineConfigs, thing_id){
    return onlineConfigs.find((config) =>
      config.Things.includes(thing_id)
    );
  }

  getCondition(conditions, id){
    return conditions.filter((con) =>
      con.condition.find((item) => item.thing_id ==id)
    );
  }

  addConfig(arr) {
    let result = [];
    for (let i = 0; i < arr["length"]; i++) {
      let config = arr[i];
      let keyText = config.key.toUpperCase();
      if (
        !keyText.includes("LOW") &&
        !keyText.includes("HIGH") &&
        !keyText.includes("EQUAL") &&
        !keyText.includes("NOT_EQUAL") &&
        !keyText.includes("BETWEEN_MAX") &&
        !keyText.includes("BETWEEN_MIN")
      ) {
        var targetValue = config.value;
        var targetKey = config.key;
      } else {
        let condition = 1;
        if (keyText.includes("LOW")) {
          condition = 2;
        } else if (keyText.includes("NOT_EQUAL")) {
          condition = 4;
        } else if (keyText.includes("EQUAL")) {
          condition = 3;
        } else if (keyText.includes("BETWEEN")) {
          condition = 5;
        }

        result.push({
          sch_status: targetValue == 1 ? "ATV" : "ITV",
          condition: condition,
          time: 5,
          target_start: config.value,
          time_unit: "minutes",
          switch_main: this.setSwitch(targetKey, keyText),
        });
      }
    }
    return result;
  }

  setSwitch(targetKey, key) {
    let switchMain = false;
    let keyText = key.toUpperCase();
    if (targetKey == "PH") {
      if (key.includes("LOW")) {
        switchMain = false;
      } else if (keyText.includes("EQUAL") || keyText.includes("NOT_EQUAL")) {
        switchMain = true;
      } else {
        switchMain = true;
      }
    } else {
      if (keyText.includes("LOW")) {
        switchMain = true;
      } else if (keyText.includes("EQUAL") || keyText.includes("NOT_EQUAL")) {
        switchMain = true;
      } else {
        switchMain = false;
      }
    }
    return switchMain;
  }

  convertOperation(config, condition){
    let keyStart = "";
    let keyEnd = "";
    if(condition.condition){
      if(parseInt(condition.condition) == 1){
        keyStart = config.group + "_HIGH";
      }else if(parseInt(condition.condition) == 2){
        keyStart = config.group + "_LOW";
      }else if(parseInt(condition.condition) == 3){
        keyStart = config.group + "_EQUAL";
      }else if(parseInt(condition.condition) == 4){
        keyStart = config.group + "_NOT_EQUAL";
      }else{
        keyStart = config.group + "_BETWEEN_MIN";
        keyEnd = config.group + "_BETWEEN_MAX";
      }
    }else{
      if(condition.operation == ">"){
        keyStart = config.group + "_HIGH";
      }else if(condition.operation == "<"){
        keyStart = config.group + "_LOW";
      }else if(condition.operation == "="){
        keyStart = config.group + "_EQUAL";
      }else if(condition.operation == "<>"){
        keyStart = config.group + "_NOT_EQUAL";
      }else{
        keyStart = config.group + "_BETWEEN_MIN";
        keyEnd = config.group + "_BETWEEN_MAX";
      }
    }
    return {
      keyStart: keyStart,
      keyEnd: keyEnd
    }
  }
}
